import { StyleSheet } from '@react-pdf/renderer';

const PrintStampStyles = StyleSheet.create({
  page: {
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 4,
    padding: '20 7 7 7',
  },
  main: {
    flexGrow: 1,
    padding: 10,
    backgroundColor: '#fff',
    fontSize: 12,
  },
  textSemiBold: {
    fontWeight: 500,
  },
  textBold: {
    fontWeight: 600,
  },
  textGrey: {
    color: '#808080',
  },
  textSm: {
    fontSize: 12,
  },
  textMd: {
    fontSize: 16,
  },
  textLg: {
    fontSize: 20,
  },
  justifyCenter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  justifyEnd: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  reportContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 5,
  },
  reportField: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 5,
    alignItems: 'center',
    padding: 3,
  },
  borderContainer: {
    border: '1px solid #111111',
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  borderBlack: {
    borderBottom: '1px solid #111111',
  },
  reportDetail: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'flex-start',
    padding: 2,
  },

  innercontainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
  },
  col6: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 2,
  },
  image200: {
    width: '100%',
    maxHeight: '200px',
    objectFit: 'cover',
  },
  underline: {
    textDecoration: 'underline',
  },
});

export default PrintStampStyles;
